'use client';

import { useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import { usePathname, useRouter } from 'next/navigation'; // 1. Added useRouter here

export default function MobileHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();
  const router = useRouter(); // 2. Initialized router here

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Membership Plans', path: '/membershipPlans' },
    { name: 'Diet Plans', path: '/dietplans' },
    { name: 'Transformations', path: '/transformations' },
    { name: 'Blogs', path: '/blogs' },
    { name: 'Join Us', path: '/join' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="flex md:hidden bg-black text-white px-4 py-2 items-center justify-between relative h-[60px] border-b border-[#1f1f1f] z-50">
        {/* Left */}
        <div className="flex items-center gap-3 z-10">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-[#faaf40] text-2xl transition-transform active:scale-90"
          >
            <FiMenu />
          </button>

          <span className="uppercase tracking-wider text-lg font-bold bg-gradient-to-r from-[#faaf40] to-white bg-clip-text text-transparent animate-gradient">
            AURA WELLNESS CLUBS
          </span>
        </div>

        {/* Right */}
        <div className="flex items-center gap-3 z-10">
          <div className="w-8 h-8 rounded-full bg-[#faaf40] flex items-center justify-center text-black font-bold text-sm select-none">
            A
          </div>
        </div>
      </div>

      {/* Mobile Menu (Drawer) */}
      <nav
        className={`
          md:hidden fixed top-[60px] left-0 w-full h-[calc(100vh-60px)] z-40
          bg-gradient-to-b from-[#1f1f1f] via-[#2c2c2c] to-[#3a2f21] 
          border-b border-[#faaf40] text-white px-4 pt-4 pb-6 
          flex flex-col overflow-y-auto
          transform transition-transform duration-500 ease-in-out
          ${menuOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* Navigation Links */}
        <div className="space-y-3">
          {navLinks.map(({ name, path }) => {
            const isActive = pathname === path;
            return (
              <a
                key={name}
                href={path}
                className={`block text-base font-medium transition-all duration-200 ease-in-out
                  ${isActive
                    ? 'text-white font-semibold border-l-4 border-[#faaf40] pl-4'
                    : 'text-[#c0c0c0] hover:text-[#faaf40] pl-5'
                  }
                `}
                onClick={() => setMenuOpen(false)}
              >
                {name}
              </a>
            );
          })}
        </div>

        <div className="h-px bg-[#4a4a4a] my-4 shrink-0" />

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 pt-2 pb-10">
          <button
            onClick={() => {
                router.push('/join');
                setMenuOpen(false); // Close menu on click
            }}
            className="text-black text-sm w-full py-2 rounded-full font-medium uppercase transition-transform duration-150 ease-in-out hover:opacity-90 active:scale-[0.98]"
            style={{
              background: 'linear-gradient(90deg, #faaf40 0%, #fcd77a 100%)',
            }}
          >
            Book Now
          </button>

          <button
            onClick={() => {
                router.push('/membershipPlans');
                setMenuOpen(false); // Close menu on click
            }}
            className="text-black text-sm w-full py-2 rounded-full font-semibold uppercase transition-transform duration-150 ease-in-out hover:opacity-90 active:scale-[0.98]"
            style={{
              background: 'linear-gradient(90deg, #faaf40 0%, #fcd77a 100%)',
            }}
          >
            Explore Plans & Reward
          </button>
        </div>
      </nav>
    </>
  );
}